import { MatchDetails } from '../../core/models/tournament.models';

/** What a blank venue is saved as. It is not a venue. */
export const VENUE_PLACEHOLDER = 'To be confirmed';

export function hasVenue(courtOrVenue: string | null | undefined): boolean {
  const venue = courtOrVenue?.trim().toLowerCase() ?? '';
  return venue !== '' && venue !== VENUE_PLACEHOLDER.toLowerCase();
}

/**
 * What a match still needs before it can be live — "both sides", "the venue",
 * or both — or null when it has everything. The database enforces the same
 * rule (matches_live_has_sides_and_venue); this just says it sooner.
 */
export function missingForLive(m: Pick<MatchDetails, 'sideAId' | 'sideBId' | 'courtOrVenue'>): string | null {
  const missing = [
    ...(!m.sideAId || !m.sideBId ? ['both sides'] : []),
    ...(!hasVenue(m.courtOrVenue) ? ['the venue'] : []),
  ];
  return missing.length ? missing.join(' and ') : null;
}
